import React from 'react';
import PropTypes from 'prop-types';
import Polyglot from 'node-polyglot';
import { withCookies } from 'react-cookie';
import * as i18n from '../../utils/i18n';

// will be rendered by server in html templates
window.phrases = {
  'sk-SK': {
    anotherLang: 'English',
    facebook: {
      loginButton: {
        label: 'Prihlásenie Facebook'
      }
    },
    donation: {
      estDays: 'Máte ešte jeden deň |||| Máte ešte %{countFormatted} dni |||| Máte ešte %{countFormatted} dní',
      estHours: 'Máte ešte hodinu |||| Máte ešte %{countFormatted} hodiny |||| Máte ešte %{countFormatted} hodín',
      estMinutes: 'Máte ešte minútu |||| Máte ešte %{countFormatted} minúty |||| Máte ešte %{countFormatted} minút',
      estSeconds: 'Máte ešte sekundu |||| Máte ešte %{countFormatted} sekundy |||| Máte ešte %{countFormatted} sekúnd',
      labels: {
        customPrice: 'Vlastná\xa0suma',
        wantMonthlyDonation: 'Chcem podporovať mesačne',
        isAnonymousDonation: 'Nezverejniť moje meno v\xa0zozname podporovateľov',
        affirmThat: 'Potvrdzujem, že som bol informovaný ',
        beenInformedDataProcessing: 'o\xa0spracovaní osobných údajov v\xa0systéme DARUJME.sk',
        isCompany: 'Chcem darovať ako Právnická osoba',
        requestConfirmation: 'Mám záujem o potvrdenie do účtovníctva'
      },
      finished: 'Výzva skončila',
      actions: {
        donate: 'Darujte'
      },
      form: {
        errors: {
          customPrice: {
            min: 'Vyberte sumu daru alebo vpíšte vlastnú'
          },
          donorFirstName: {
            required: 'Vyplňte svoje meno'
          },
          donorLastName: {
            required: 'Vyplňte svoje priezvisko'
          },
          donorEmail: {
            required: 'Vyplňte svoju e-mailovú adresu',
            email: 'Vaša e-mailová adresa je neplatná',
          },
          paymentMethod: {
            required: 'Vyberte platobnú metódu'
          },
          affirmDataProcessing: {
            equals: 'Musíte potvrdiť, že ste boli informovaný o\xa0spracovaní osobných údajov'
          }
        }
      }
    },
    login: {
      form: {
        title: 'Prihlásenie',
        labels: {
          email: 'E-mailová adresa',
          password: 'Heslo',
        },
        actions: {
          login: 'Prihlásiť sa',
          loginFacebook: 'Prihlásenie Facebook',
          forgotPassword: 'Zabudol som heslo'
        },
        errors: {
          email: {
            required: 'Prosím, zadajte vašu emailovú adresu',
            email: 'Prosím, zadajte platnú emailovú adresu'
          },
          password: {
            required: 'Prosím, vyplňte svoje heslo'
          }
        }
      }
    },
    profileEditor: {
      form: {
        errors: {
          firstName: {
            required: 'Prosím, vyplňte svoje meno'
          },
          lastName: {
            required: 'Prosím, vyplňte svoje priezvisko'
          },
          email: {
            required: 'Prosím, zadajte vašu emailovú adresu',
            email: 'Prosím, zadajte platnú emailovú adresu',
            unique: 'Zadanú e-mailovú adresu už používa iný autor darovacej výzvy'
          },
          password: {
            required: 'Prosím, vytvorte si heslo',
            minLength: 'Prosím, vytvorte si heslo, ktoré má aspoň osem znakov'
          }
        },
        title: 'Vytvorenie konta',
        labels: {
          firstName: 'Meno',
          lastName: 'Priezvisko',
          email: 'E-mailová adresa',
          password: 'Heslo',
          agreeToPersonalDataProcessing: 'Súhlasím so spracovaním osobných údajov'
        },

        success: 'Vaše zmeny boli úspešne uložené'
      }
    },
    campaignCreator: {
      form: {
        errors: {
          companyName: {
            required: 'Prosím, vyplňte názov vyhlasovateľa',
            minLength: 'Názov vyhlasovateľa musí obsahovať aspoň 10 znakov'
          },
          campaignName: {
            required: 'Prosím, vyplňte názov vašej výzvy',
            minLength: 'Názov vašej výzvy musí obsahovať aspoň 10 znakov'
          },
          targetAmount: {
            required: 'Prosím, vyplňte sumu',
            min: 'Cieľová suma musí byť aspoň 100 €',
            max: 'Cieľová suma môže byť maximálne 10 000 €',
          },
          agreeToTermsAndConditions: {
            equals: 'Prosím, potvrďte súhlas s podmienkami používania'
          },
          affirmDataProcessing: {
            equals: 'Prosím vyjadrite svoj súhlas so spracovaním osobných údajov'
          }
        },
        title: 'Nová darovacia výzva',
        labels: {
          campaignName: 'Ako sa bude volať vaša kampaň?',
          campaignNameHelp: 'Napríklad: Narodeniny pre deti v núdzi. Zachráňme spolu školu v Afrike.',
          targetAmount: 'Cieľová suma \u2014 koľko chcete vyzbierať',
          targetAmountHelp: 'Spolu s vašou rodinou, kamarátmi a známymi, akú sumu môžete spoločne vyzbierať? Buďte realistický, ale ambiciózny.',
          agreeTo: 'Súhlasím s ',
          termsAndConditions: 'podmienkami používania DARUJME.sk',
          affirmThat: 'Potvrdzujem, že som bol informovaný ',
          beenInformedDataProcessing: 'o spracovaní osobných údajov v systéme DARUJME.sk',
          agreeToPersonalDataProcessing: 'Súhlasím so spracovaním uvedených ',
          isCompany: "Chcem vytvoriť výzvu ako právnická osoba",
          companyName: "Názov vyhlasovateľa výzvy",
          requestedMatching: "Chcem ako firma znásobiť dary"
        },
        actions: {
          createCampaign: 'Vytvorte výzvu',
          continue: 'Vytvorte výzvu'
        }
      }
    },
    campaignEditor: {
      form: {
        errors: {
          companyName: {
            required: 'Prosím, vyplňte názov vyhlasovateľa',
            minLength: 'Názov vyhlasovateľa musí obsahovať aspoň 10 znakov'
          },
          campaignName: {
            required: 'Prosím, vyplňte názov vašej výzvy',
            minLength: 'Názov vašej výzvy musí obsahovať aspoň 10 znakov'
          },
          targetAmount: {
            required: 'Prosím, vyplňte sumu',
            min: 'Cieľová suma musí byť aspoň 100 €',
            max: 'Cieľová suma môže byť maximálne 10 000 €'
          },
          lengthInDays: {
            required: 'Prosím, vyplňte dĺžku trvania výzvy',
            min: 'Dĺžka trvania výzvy nemôže byť v minulosti',
            max: 'Dĺžka trvania výzvy nemôže byť viac ako 90 dní'
          },
          description: {
            required: 'Prosím, vyplňte popis výzvy'
          }
        },
        title: 'Úprava vašej výzvy',
        labels: {
          campaignName: 'Dajte svojej výzve názov',
          targetAmount: 'Cieľová suma',
          lengthInDays: 'Dĺžka trvania výzvy',
          campaignEndsOn: 'Darovacia výzva končí %{formattedDate}',
          campaignRemainingDaysUntilEnd: 'máte ešte %{smart_count} deň |||| máte ešte %{smart_count} dni |||| máte ešte %{smart_count} dní',
          description: 'Popis výzvy',
          descriptionNote: 'Toto je predvolený text výzvy, ktorý si môžete upraviť podľa svojich predstáv.\u000APrečo ste sa rozhodli vytvoriť darcovskú výzvu? Čím je organizácia výnimočná a prečo ju máte radi? Ako jej finančná podpora môže pomôcť?\u000APokúste sa ľudí presvedčiť a motivovať \u2014 napríklad tým, že ak spoločne dosiahnete stanovaný cieľ, spravíte niečo čo by od vás nečakali.\u000APoproste ich, aby výzvu šírili ďalej.',
          images: 'Titulné fotografie',
          imagesNote: 'Fotografia zobrazená v pozadí výzvy.',
          imagesNoteAndUploadNote: 'Fotografia zobrazená v pozadí výzvy. Ak idete pridať vlastnú fotografiu, ideálne rozlíšenie je 1920 \u00D7 550 pixelov a formát JPEG.',
          uploadCustomImage: 'Pridajte vašu vlastnú fotografiu',
          companyName: "Názov vyhlasovateľa"
        },
        actions: {
          saveCampaign: 'Uložiť výzvu',
          cancel: 'Zrušiť zmeny'
        }
      }
    },
    register: {
      form: {
        errors: {
          firstName: {
            required: 'Prosím, vyplňte svoje meno'
          },
          lastName: {
            required: 'Prosím, vyplňte svoje priezvisko'
          },
          email: {
            required: 'Prosím, vyplňte svoju emailovú adresu',
            email: 'Prosím, zadajte platnú emailovú adresu',
            unique: 'Zadanú emailovú adresu už používa iný autor darovacej výzvy'
          },
          password: {
            required: 'Prosím, vyplňte svoje heslo',
            minLength: 'Vaše heslo musí mať aspoň osem znakov'
          },
          phone: {
            required: 'Prosím, vyplňte svoje telefónne číslo'
          },
          agreeToPersonalDataProcessing: {
            required: 'Prosím, vyjadrite svoj súhlas so spracovaním osobných údajov'
          }
        },
        title: 'Vytvorenie konta',
        labels: {
          firstName: 'Meno',
          lastName: 'Priezvisko',
          email: 'E-mailová adresa',
          password: 'Heslo',
          phone: 'Telefónne číslo'
        }
      }
    },
    passwordReset: {
      form: {
        errors: {
          email: {
            required: 'Prosím, vyplňte svoju emailovú adresu',
            email: 'Prosím, zadajte platnú emailovú adresu'
          },
          password: {
            required: 'Prosím, vyplňte svoje nové heslo',
            length: 'Vaše nové heslo musí byť aspoň osem znakov dlhé (maximálne však 100 znakov)'
          },
          passwordRepeat: {
            required: 'Prosím, vyplňte svoje nové heslo ešte raz',
            length: 'Vaše nové heslo musí byť aspoň osem znakov dlhé (maximálne však 100 znakov)',
            equals: 'Zadané heslá sa nezhodujú'
          }
        }
      }
    },
    cookieConsent: {
      main: {
        shortInfo: 'Niektoré sú naozaj potrebné a bez nich by stránka vôbec nefungovala.',
        explanation: 'Analytické cookies používame na zlepšovanie funkčnosti stránky, personalizačné cookies na jej prispôsobenie pre vás a marketingové cookies na zobrazenie relevantnej reklamy. ',
        plead: 'Veľmi by nám pomohlo, keby sme mohli používať všetky tieto cookies.',
        buttonSettings: 'Nastavenie',
        buttonRejectAll: 'Len potrebné',
        buttonAcceptAll: 'Prijať všetko'
      },
      settings: {
        essential: 'Tieto cookies zabezpečujú správne fungovanie nášho webu. Napríklad funkciu prihlásenia sa ' +
          'do používateľského konta. Pomáhajú nám tiežodhaľovať pokusy o neoprávnené prihlásenie a ' +
          'umožňujú efektívne zobrazovanie obsahu.',
        marketing: 'Tieto cookies používame na to, aby sme vám zobrazovali čo najzaujímavejšiu reklamu.' +
          'Slúžia tiež na vykonávanie obdobných marketingových činností prostredníctvom tretích strán' +
          '(cez našich reklamných partnerov a sa sociálne siete). Tieto cookies sprostredkúvame aj v' +
          'niektorých prípadoch aj zaregistrovaným organizáciám, ktorým patrí daná darovacia stránka,' +
          'za účelom optimalizácie ich marketingových činností pre ich fundraising.',
        analytic: 'Tieto cookies nám slúžia na zisťovanie anonymných údajov o návštevnosti nášho webu. Môžu ' +
          'hovoriť o tom, odkiaľ ste k nám prišli, o vyhľadávaniach na našom webe, či ako sa ' +
          'pohybujete po našej stránke, vďaka čomu ju môžeme neustále zlepšovať. Získané údaje nám ' +
          'umožňujú tiež spracovávať štatistiky.',
        cookieTypeEssential: 'Potrebné',
        cookieTypeAnalytic: 'Analytické',
        cookieTypeMarketing: 'Marketingové',
        buttonBack: 'Naspäť',
        buttonSave: 'Uložiť nastavenia'
      },
      common: {
        title: 'Príjmete naše cookies?',
        moreInfo: 'Viac info...',
        lessInfo: 'Menej info...',
        cookieConsentLink: 'Súhlas s používaním cookies'
      }
    }
  },
  'en-GB': {
    anotherLang: 'Slovenčina',
    campaign: {
      create: 'Create campaign',
      est: 'you have %{smart_count} day |||| you have %{smart_count} days',
      form: {
        errors: {
          campaign: {
            required: 'Insert campaign name'
          }
        }
      }
    }
  }
};

class LangProvider extends React.Component {
  static childContextTypes = {
    lang: PropTypes.object,
    t: PropTypes.func,
    formatters: PropTypes.object
  };

  constructor(props) {
    super(props);
    const { cookies } = props;

    this.state = {
      lang: cookies.get(window.DRJM.config.cookieLangName) || i18n.defaultLocale
    };

    this.polyglot = this.createNewPolyglot(this.state.lang);
  }

  getChildContext() {
    const { lang } = this.state;

    const formatters = {
      formatNumber: (...args) => i18n.formatNumber(lang, ...args),
      formatCurrency: (...args) => i18n.formatCurrency(lang, ...args),
    };

    return {
      lang: {
        current: lang,
        changeLang: this.changeLang,
        polyglot: this.polyglot,
      },
      t: this.polyglotTranslateShortcut,
      formatters
    };
  }

  polyglotTranslateShortcut = (msg, interpolate, count) =>
    this.polyglot.t(msg, { smart_count: count, ...interpolate });

  createNewPolyglot = (lang) =>
    new Polyglot({
      phrases: window.phrases[lang],
      locale: lang === 'sk-SK' ? 'cs' : 'en' // polyglot neuznava slovencinu
    });

  changeLang = (lang) => {
    const { cookies } = this.props;

    this.polyglot = this.createNewPolyglot(lang);

    this.setState({ lang });

    cookies.set(window.DRJM.config.cookieLangName, lang, { path: '/' });

    const e = new CustomEvent('language', { detail: lang });
    document.dispatchEvent(e);
  };

  render() {
    return this.props.children;
  }
}

export default withCookies(LangProvider);



// WEBPACK FOOTER //
// ./app/Assets/js/features/components/LangProvider.js